export default {
  path: 'manage-development-role',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage Development Role',
      component: () => import('@/views/menus/developmentRole/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
